import type { AccountInfo } from '@azure/msal-browser'
import { createContext } from 'react'

export interface AuthContextType {
  isAuthenticated: boolean
  isLoading: boolean
  account: AccountInfo | null
  displayName: string
  error: string | null
  login: () => Promise<void>
  getAccessToken: (options?: { forceRefresh?: boolean }) => Promise<string | null>
}

export const AuthContext = createContext<AuthContextType | undefined>(undefined)
